import React from 'react';
import ButtonAction from '../../../_common/components/ButtonAction';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {getCustomerDetailsLink} from '../../../_common/utils/url';
import PopupDeleteRestoreCustomer from '../PopupDeleteRestoreCustomer';
import ButtonDD from "../../../_common/components/ButtonDD";

export function CustomersActionsColumnFormatter(cellContent, {history}) {
  const {customerID, greenInvoiceClientID} = cellContent;
  const goToCustomer = () => history.push(getCustomerDetailsLink(customerID, greenInvoiceClientID))

  return (
    <div className="d-flex justify-content-end align-items-center">
      <ButtonDD
        items={[{
          itemContent: (
            <div className="d-flex justify-content-between align-items-center">
              <ButtonAction
                variant={'icon'}
                iconButtonType={'primary'}
                title={TTS.EDIT_CUSTOMER}
                onClick={goToCustomer}
                disabled={!can(T.FULL, S.CUSTOMERS_ENTITY_PAGE)}
                label={<img src={toAbsoluteUrl('media/common/Edit_primary.svg')} alt="edit"/>}
                customClassnames={'mx-2'}
              />
              <PopupDeleteRestoreCustomer data={cellContent}/>
            </div>
          )
        }
        ]}
      />
    </div>
  );
}
